import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.宇通)
export class 宇通TenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    // super.register();
    const { ProjectionSettingReplenisherYutong } = await import(
      '../../plugins/service_plugins/projection_setting_replenisher/projection_setting_replenisher_yutong'
    );
    registerPlugin(ProjectionSettingReplenisherYutong);

    // 注册宇通默认配置获取插件
    const { DefaultProjectionSettingConfigProviderYutong } = await import(
      '../../plugins/service_plugins/default_projection_setting_config_provider/default_projection_setting_config_provider_yutong'
    );
    registerPlugin(DefaultProjectionSettingConfigProviderYutong);
  }
}
